import React, { useState } from 'react';
import AllContests from "./AllContests";
import TrainingCourses from "./TrainingCourses";
import SeminarsAll from "./SeminarsAll";
import ConferencesAll from "./ConferencesAll";
import { useTranslation } from "../../context/TranslationContext"; 
import SectionTabs from "../../component/SectionTabs"; 

export default function Allactivity() {
  const { translations, language } = useTranslation(); 
  const isArabic = language === "ar";
  const [selectedSection, setSelectedSection] = useState("allContests");

  const sections = {
    allContests: {
      label: translations.contestsButton,
      component: <AllContests />,
    },
    TrainingCourses: {
      label: translations.trainingCoursesButton,
      component: <TrainingCourses />,
    },
    allConferences: {
      label: translations.conferencesButton,
      component: <ConferencesAll />,
    },
    allSeminars: {
      label: translations.seminarsButton,
      component: <SeminarsAll />,
    },
  };

  const handleSelectChange = (event) => {
    setSelectedSection(event.target.value);
  };

  return (
    <div className={`flex ${isArabic ? 'flex-col md:flex-row' : 'flex-col-reverse md:flex-row-reverse'} pt-24 w-full`}>
      <div
        className="flex-1"
        style={{
          fontFamily: "Tajwal, sans-serif",
          direction: isArabic ? "rtl" : "ltr",
          textAlign: isArabic ? "right" : "left",
        }}
      >
        <h2 className="text-xl font-bold mb-1">{translations.activity}</h2>
        <h4 className="text-l font-bold text-gray-500 mb-4">{translations.activityDescription}</h4>

        {/* القوائم المنسدلة للأجهزة الصغيرة */}
        <div className="sm:hidden mt-4">
          <select
            className="w-full px-4 py-2 rounded-lg border border-gray-300 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-blue"
            value={selectedSection}
            onChange={handleSelectChange}
          >
            {Object.entries(sections).map(([key, section]) => (
              <option key={key} value={key}>
                {section.label}
              </option>
            ))}
          </select>
        </div>

        {/* الأزرار للشاشات الكبيرة */}
        <div className="hidden sm:flex flex-wrap justify-center md:justify-start gap-2 mt-4">
          {Object.entries(sections).map(([key, section]) => (
            <button
              key={key}
              onClick={() => setSelectedSection(key)}
              className={`flex items-center px-4 py-2 rounded-lg text-l font-bold text-gray-900 bg-blue hover:bg-primary-blue hover:text-white focus:outline-none ${
                selectedSection === key ? "bg-primary-blue text-white" : ""
              }`}
            >
              {section.label}
            </button>
          ))}
        </div>

        <hr className="my-2 border-gray-200 mb-10" />

        {/* عرض المكون المختار */}
        {sections[selectedSection]?.component}
      </div>
    </div>
  );
}
